import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";

export function PathLink(props){
    const items=props.items.map((item)=>{
        return {
            label:item.name,
            link:item.link,
            template:()=> <Button severity="secondary" size="small" text onClick={(e)=>onClick(item)} 
                className="white-space-nowrap overflow-hidden text-overflow-ellipsis block p-0" 
                label={item.name}></Button>
        }
    });
    const onClick=(item)=>{
        console.log("PathLink:onClick:"+item.link);
        if(props.nav)
            props.nav(item.link);
        if(props.onSelect)
            props.onSelect(item.link);
    }
    return(
        <BreadCrumb model={items} className="p-2 mt-1 mb-2"/>
    )
}